module.exports = __webpack_public_path__ + "static/media/forklift.8d5dafdb.svg";